import {useEffect, useState} from 'react'

import jsCookie from '@s-ui/js/lib/cookie'

const SMARTBANNER_COOKIE_NAME = 'mt_smartbanner_cooldown'

export const useCooldownSmartbanner = () => {
  const [allowRenderBasedOnCooldown, setAllowRenderBasedOnCooldown] = useState(false)

  const setCooldownPeriod = hours => {
    const currentTime = new Date().getTime()
    const expirationTimestamp = currentTime + hours * 60 * 60 * 1000

    const cooldownData = {
      timestamp: currentTime,
      expirationTimestamp
    }

    jsCookie.set(SMARTBANNER_COOKIE_NAME, JSON.stringify(cooldownData), {expires: 30})
  }

  const clearCooldownData = () => {
    jsCookie.remove(SMARTBANNER_COOKIE_NAME)
  }

  useEffect(() => {
    if (typeof window === 'undefined') return

    const checkCooldown = async () => {
      try {
        const cooldownCookie = await jsCookie.get(SMARTBANNER_COOKIE_NAME)

        if (!cooldownCookie) {
          setAllowRenderBasedOnCooldown(true)
          return
        }

        const {expirationTimestamp} = JSON.parse(cooldownCookie)
        const currentTime = new Date().getTime()

        if (currentTime > expirationTimestamp) {
          setAllowRenderBasedOnCooldown(true)
          clearCooldownData()
        } else {
          setAllowRenderBasedOnCooldown(false)
        }
      } catch (error) {
        setAllowRenderBasedOnCooldown(true)
        clearCooldownData()
        console.error('Error checking smartbanner cooldown', error)
      }
    }

    checkCooldown()
  }, [])

  return {
    setCooldownPeriod,
    setAllowRenderBasedOnCooldown,
    allowRenderBasedOnCooldown
  }
}
